import { render, staticRenderFns } from "./penaltyDetail.vue?vue&type=template&id=2f0a9a2c"
import script from "./penaltyDetail.vue?vue&type=script&lang=js"
export * from "./penaltyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f0a9a2c')) {
      api.createRecord('2f0a9a2c', component.options)
    } else {
      api.reload('2f0a9a2c', component.options)
    }
    module.hot.accept("./penaltyDetail.vue?vue&type=template&id=2f0a9a2c", function () {
      api.rerender('2f0a9a2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/penalty/penaltyDetail.vue"
export default component.exports